import { render, staticRenderFns } from "./CookieBannerWidget.vue?vue&type=template&id=7ba00fea&"
import script from "./CookieBannerWidget.vue?vue&type=script&lang=js&"
export * from "./CookieBannerWidget.vue?vue&type=script&lang=js&"
import style0 from "./CookieBannerWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VDialog,VSnackbar})
